﻿import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Chart, ChartData, Point, ChartColor } from 'chart.js';
import { CurrentConvocationMembers } from '../../../core/models/council-members/current-convocation-members';
import 'chartjs-plugin-datalabels';
import { SharedService } from '../../../shared/shared.service';
import { DropdownItem } from '../../../core/models/dropdown-item';
import { ConvocationDropdownItem } from '../../../core/models/administration/global-codes/convocation/convocation-dropdown-item';
import { CouncilMembersService } from '../../council-members/council-members.service';
import { LanguageService } from '../../../core/language/language.service';
import { Input } from '@angular/core';
import { CONFIG } from '../../../core/config';



export class NumberOfQuestionsAndAnswers {
    numberOfQuestions: number;
    numberOfAnswers: number;
}

export class ListByAnswerTime {
    id: number;
    questionsList: QuestionsModel[] = [];
}

export class QuestionsModel {
    id: number;
    answerTime: number;
    answerTimeFormatted: string;
}

export class NumberOfQuestionsByGender {
    sexId: number;
    sexName: string;
    number: number;
}

export class NumberOfQuestionsBySensitiveCategory {
    sensitiveCategoryId: number;
    sensitiveCategoryName: string;
    number: number;
}

export class NumberOfQuestionsByYearGroup {
    number: number;
    numberYear: number;
}

export class NumberOfAnsweredAndNotAnsweredQuestions {
    id: number;
    name: string;
    numberOfQuestions: number;
    numberOfAnswered: number;
    numberOfNotAnswered: number;
}

export class ListAverageAnswerTime {
    id: number;
    name: string;
    averageAnswerTime: number;
    averageAnswerTimeFormatted: string;
}

export class MemberModel {
    languageId: number;
    convocationId: number;
    memberId: number;
    questionDateTo: Date;
    questionDateFrom: Date;
    memberTypeId: number;
}

export class ConvocationModel {
    languageId: number;
    convocationId: number;
}

@Component({
    selector: 'app-council-member-statistic',
    templateUrl: './council-member-statistic.component.html'
})

export class CouncilMemberStatisticComponent implements OnInit {
    @Input() izabranaKategorija: number;
    @Output() numberOfQuestionsAnswersList: EventEmitter<NumberOfQuestionsAndAnswers> = new EventEmitter<NumberOfQuestionsAndAnswers>();
    @Output() listByAnswerTime: EventEmitter<ListByAnswerTime> = new EventEmitter<ListByAnswerTime>();
    @Output() numberOfQuestionsByGender: EventEmitter<NumberOfQuestionsByGender[]> = new EventEmitter<NumberOfQuestionsByGender[]>();
    @Output() numberOfQuestionsBySensitiveCategory: EventEmitter<NumberOfQuestionsBySensitiveCategory[]> = new EventEmitter<NumberOfQuestionsBySensitiveCategory[]>();
    @Output() numberOfQuestionsByYearGroup: EventEmitter<NumberOfQuestionsByYearGroup[]> = new EventEmitter<NumberOfQuestionsByYearGroup[]>();
    @Output() numberOfAnsweredAndNotAnsweredQuestions: EventEmitter<NumberOfAnsweredAndNotAnsweredQuestions[]> = new EventEmitter<NumberOfAnsweredAndNotAnsweredQuestions[]>();
    @Output() listAverageAnswerTime: EventEmitter<ListAverageAnswerTime[]> = new EventEmitter<ListAverageAnswerTime[]>();

    

    public currentConvocationMembers: CurrentConvocationMembers[] = [];
    public councilMembers: any[] = [];
    private languageID: number;
    public convocations: ConvocationDropdownItem[] = [];

    public memberModel: MemberModel;
    public convocationModel: ConvocationModel;

    private membersQuestionsAnswersList: NumberOfQuestionsAndAnswers;
    private membersByAnswerTime: ListByAnswerTime;
    private memberNumberOfQuestionsByGender: NumberOfQuestionsByGender[] = [];
    private memberNumberOfQuestionsBySensitiveCategory: NumberOfQuestionsBySensitiveCategory[] = [];
    private memberNumberOfQuestionsByYearGroup: NumberOfQuestionsByYearGroup[] = [];
    private memberNumberOfAnsweredAndNotAnsweredQuestions: NumberOfAnsweredAndNotAnsweredQuestions[] = [];
    private memberListAverageAnswerTime: ListAverageAnswerTime[] = [];


    constructor(private _councilMembersService: CouncilMembersService,
        private _languageService: LanguageService,
        private _sharedService: SharedService) {
        this.languageID = this._languageService.selectedLanguageId;
        this.memberModel = new MemberModel();
        this.convocationModel = new ConvocationModel();
        
    }

    ngOnInit() {
        this._sharedService.getAllConvocationsForDropdown(0, true, this.languageID).subscribe(result => {
            this.convocations = result;
            this.initConvocationModel();
            this._councilMembersService.getCouncilMembersByConvocationID(this.convocationModel).subscribe(result => {
                this.councilMembers = result;
                this.initMemberModel();
            });
        });


    }
    ngOnChanges() {
        this._sharedService.getAllConvocationsForDropdown(0, true, this.languageID).subscribe(result => {
            this.convocations = result;
            this.initConvocationModel();
            this._councilMembersService.getCouncilMembersByConvocationID(this.convocationModel).subscribe(result => {
                this.councilMembers = result;
                this.initMemberModel();
            });
        });
    }


    initMemberModel() {
        console.log(this.izabranaKategorija);
        this.memberModel.languageId = this._languageService.selectedLanguageId;
        this.memberModel.convocationId = this.convocationModel.convocationId;
        this._councilMembersService.getMayorByMemberTypeIdAndConvocationId({ memberTypeID: CONFIG.memberType.Mayor, convocationId: this.memberModel.convocationId }).subscribe(result => {
            if (this.izabranaKategorija == CONFIG.categoriesDropdownEnuum.mayor) {
                this.memberModel.memberId = result.memberId;
                this.memberModel.memberTypeId = CONFIG.memberType.Mayor;
                this.councilMembers = this.councilMembers.filter(x => x.id == this.memberModel.memberId);
                this.generateChartData();
            }
            else {
                this.memberModel.memberId = 0;
                this.memberModel.memberTypeId = CONFIG.memberType.CouncilMember;
                this.councilMembers = this.councilMembers.filter(x => x.id != result.memberId);
                this.generateChartData();
            }
        });

        this.memberModel.questionDateFrom = null;
        this.memberModel.questionDateTo = null;
    }

    initConvocationModel() {
        this.convocationModel.languageId = this._languageService.selectedLanguageId;
        this.convocationModel.convocationId = this.convocations.filter(x => x.isCurrentConvocation)[0].id;
    }

    onConvocationChange(id: number) {
        this.convocationModel.convocationId = id;
        this._councilMembersService.getCouncilMembersByConvocationID(this.convocationModel).subscribe(result => {
            this.councilMembers = result;

            this.initMemberModel();
        });
    }

    onMemberChange(id: number) {
        this.memberModel.memberId = id;
        this.generateChartData();
    }

    onQuestionDateFromChanged(date: Date) {
        this.memberModel.questionDateFrom = date;
        this.generateChartData();
    }

    onQuestionDateToChanged(date: Date) {
        this.memberModel.questionDateTo = date;
        this.generateChartData();
    }

    //getCouncilMembersForCurrentConvocation() {
    //    this._councilMembersService.getCouncilMembersForCurrentConvocation(this.languageID).subscribe(result => {
    //        this.currentConvocationMembers = result;
    //    });
    //}

    getMemberListByAnswerTime() {
        this._councilMembersService.getMemberListByAnswerTime(this.memberModel).subscribe(result => {
            this.membersByAnswerTime = result;
            this.listByAnswerTime.emit(this.membersByAnswerTime);
        });
    }

    getNumberOfCouncilMembers() {
        this._councilMembersService.getNumberOfMemberQuestionsAndAnswers(this.memberModel).subscribe(result => {
            this.membersQuestionsAnswersList = result;
            this.numberOfQuestionsAnswersList.emit(this.membersQuestionsAnswersList);
        });
    }

    getNumberOfQuestionsByGender() {
        this._councilMembersService.getNumberOfQuestionsByGender(this.memberModel).subscribe(result => {
            this.memberNumberOfQuestionsByGender = result;
            this.numberOfQuestionsByGender.emit(this.memberNumberOfQuestionsByGender);
        });
    }

    getNumberOfQuestionsBySensitiveCategory() {
        this._councilMembersService.getNumberOfQuestionsBySensitiveCategory(this.memberModel).subscribe(result => {
            this.memberNumberOfQuestionsBySensitiveCategory = result;
            this.numberOfQuestionsBySensitiveCategory.emit(this.memberNumberOfQuestionsBySensitiveCategory);
        });
    }

    getNumberOfQuestionsByYearGroup() {
        this._councilMembersService.getNumberOfQuestionsByYearGroup(this.memberModel).subscribe(result => {
            this.memberNumberOfQuestionsByYearGroup = result;
            this.numberOfQuestionsByYearGroup.emit(this.memberNumberOfQuestionsByYearGroup);
        });
    }

    getNumberOfAnsweredAndNotAnswered() {
        this._councilMembersService.getNumberOfAnsweredAndNotAnsweredQuestions(this.memberModel).subscribe(result => {
            this.memberNumberOfAnsweredAndNotAnsweredQuestions = [];
            result.forEach(value => {
                this.memberNumberOfAnsweredAndNotAnsweredQuestions.push({
                    id: value.memberId,
                    name: value.memberName,
                    numberOfQuestions: value.numberOfQuestions,
                    numberOfAnswered: value.numberOfAnswered,
                    numberOfNotAnswered: value.numberOfNotAnswered
                });
            });
            this.numberOfAnsweredAndNotAnsweredQuestions.emit(this.memberNumberOfAnsweredAndNotAnsweredQuestions);
        });
    }

    getMemberListAverageAnswerTime() {
        this._councilMembersService.getMemberListAverageAnswerTime(this.memberModel).subscribe(result => {
            this.memberListAverageAnswerTime = [];
            result.forEach(value => {
                this.memberListAverageAnswerTime.push({
                    id: value.memberId,
                    name: value.memberName,
                    averageAnswerTime: value.averageAnswerTime,
                    averageAnswerTimeFormatted: value.averageAnswerTimeFormatted,
                });
            });
            this.listAverageAnswerTime.emit(this.memberListAverageAnswerTime);
        });
    }
    //emitProps() {
    //    this.numberOfQuestionsAnswersList.emit(this.membersQuestionsAnswersList);
    //    this.listByAnswerTime.emit(this.membersByAnswerTime);
    //    this.numberOfQuestionsByGender.emit(this.memberNumberOfQuestionsByGender);
    //    this.numberOfQuestionsBySensitiveCategory.emit(this.memberNumberOfQuestionsBySensitiveCategory);
    //    this.numberOfQuestionsByYearGroup.emit(this.memberNumberOfQuestionsByYearGroup);
    //    this.numberOfAnsweredAndNotAnsweredQuestions.emit(this.memberNumberOfAnsweredAndNotAnsweredQuestions);
    //    this.listAverageAnswerTime.emit(this.memberListAverageAnswerTime);
    //}
    generateChartData() {
        this.getNumberOfCouncilMembers();
        this.getMemberListByAnswerTime();
        this.getNumberOfQuestionsByGender();
        this.getNumberOfQuestionsBySensitiveCategory();
        this.getNumberOfQuestionsByYearGroup();
        this.getNumberOfAnsweredAndNotAnswered();
        this.getMemberListAverageAnswerTime();
    }

}